module.exports = __webpack_public_path__ + "static/media/difusion-red.918e73b3.jpg";